import {
  PaymentProcessor,
  PaymentProcessorEncryptor,
  PaymentProcessorOptions
} from "./PaymentProcessor.js"
import { loadScript, PayPalNamespace } from "@paypal/paypal-js"

export enum PaypalPaymentProcessorTypes {
  PAYPAL = 'PAYPAL'
}

interface PaypalPaymentProcessorOptions extends PaymentProcessorOptions {
}

interface PayPalPaymentProcessorEncryptor extends PaymentProcessorEncryptor {

}

export class PaypalPaymentProcessor extends PaymentProcessor {
  isInitializing: boolean = true
  initialized: boolean = false
  processorType: PaypalPaymentProcessorTypes = PaypalPaymentProcessorTypes.PAYPAL
  processorKey: string = ""
  processorOptions: PaypalPaymentProcessorOptions = {}
  processorAPI!: PayPalNamespace

  public async fetchProcessor (
    processorType: PaypalPaymentProcessorTypes,
    processorKey: string,
    processorOptions: PaypalPaymentProcessorOptions,
    onProcessorLoad: () => void
  ): Promise<PaypalPaymentProcessor> {
    this.processorType = processorType
    this.processorKey = processorKey
    this.processorOptions = processorOptions
    this.onProcessorLoad = onProcessorLoad ?? (() => {})
    this.initialize()

    try {
      await this.waitUntilReady()
    } catch (_e) {
      throw new Error('PaypalPaymentProcessor::fetchProcessor(): Failed to initialize Stripe')
    }

    return this
  }

  getToken (_tokenInput: unknown, _options: { [key: string]: any }): Promise<PayPalPaymentProcessorEncryptor> {
    return new Promise((_resolve, _reject) => {
      // TODO provide a token from paypal
    })
  }

  initialize (): void {
    if (this.initialized) {
      // if Paypal is already loaded, we can initialize the client instance immediately
      return
    }

    loadScript({
      clientId: this.processorKey
    }).then((paypalAPI: PayPalNamespace | null) => {
      if (paypalAPI) {
        this.processorAPI = paypalAPI
      }
      this.onScriptLoad()
    }).catch(_error => {
      throw new Error('Paypal API failed to load')
    })
  }

  onScriptLoad (): void {
    this.isInitializing = false
    this.initialized = true
  }
}
